import type { IconSvgObject } from './types';

const LeftToRightListStarIcon: IconSvgObject = [
  ["path", { d: "M12 5.5L21 5.5", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 12L21 12", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 18.5L21 18.5", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M8 5.5H3M4.04167 8L6.95833 3M6.95833 8L4.04167 3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M8 18.5H3M4.04167 21L6.95833 16M6.95833 21L4.04167 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default LeftToRightListStarIcon;
